<template>
  <I18nLinkWithFallback
    name="essays-slug"
    :localizedData="attributes"
    :class="$style.root"
  >
    <div :class="$style.info">
      {{ title }}
    </div>
    <div :class="$style.author">
      {{ author }}
    </div>

    <CoreDateTimeRangeComponent
      :class="$style.date"
      v-if="attributes?.date_posted"
      :dateStart="attributes?.date_posted"
    />

    <CoreImageComponent
      v-if="attributes?.cover_image?.data?.attributes"
      :image="attributes?.cover_image?.data?.attributes"
      :class="$style.image"
      :includeCaption=false
    />

    <CoreTextComponent
      v-if="firstParagraph"
      :string="firstParagraph"
      :class="$style.text"
    />

    <button :class="$style.button">
      {{ $t('shared.more')  }}
    </button>
  </I18nLinkWithFallback>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const attributes = computed(() => {
  return baseStrapiGetAttributes(props?.data)
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(attributes?.value)
})

const title = computed(() => i18nGetLocalizedTitle(localizedData?.value))
const author = computed(() => i18nGetLocalizedString(localizedData?.value?.authors))

const firstParagraph = computed(() => {
  return baseTruncateString(i18nGetLocalizedString(localizedData.value?.blocks?.find(block => block.__component === 'blocks.text')), 44)
})
</script>

<style module>
.root {
  composes: reset-link from global;

  --base--image--aspect-ratio: 9 / 6;
  --base--image--object-fit: contain;
}

.image {
  transition: filter var(--transition--default);
}

.root:has(.button):hover .image {
  filter: invert(100%) grayscale(100%);
}

.info {
  composes: font-size-large from global;
  text-align: center;
}

.author {
  composes: font-size-medium from global;
  text-align: center;
}

.date {
  composes: font-size-medium from global;
  text-align: center;
  display: block;
  color: var(--color--secondary);
}

.text {
  composes: font-size-small from global;
}

.image {
  margin: var(--unit--vertical) auto;
}

.button {
  composes: reset-button link-box from global;
  margin: auto;
  margin-top: var(--unit--vertical);
  display: block;
}
</style>
